import React from 'react';
import { ChevronDownOutline } from 'react-ionicons';
export const ArrowDown = () => {
    return <ChevronDownOutline width="16px" color="#545cd8" />;
};
